import { Box, Button, Paper, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Link, useLocation } from 'react-router-dom';

import usePlatform from '../../hooks/usePlatform';
import { DEFAULT_PLATFORM } from '../../platformConfig';
import { PlatformRoot } from '../../routes';

// Catch-all for unknown URLs. Reached in two cases: a valid platform with an
// unknown path (renders inside the app chrome, so the sidebar is still there),
// and an unrecognised `:platform` segment (renders standalone, because the
// chrome cannot resolve a platform to scope itself to).
const NotFoundPage = () => {
  const platform = usePlatform();
  const { pathname } = useLocation();
  const homeLink = PlatformRoot.getLink({ platform: platform ?? DEFAULT_PLATFORM });

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        minHeight: 320,
      }}
    >
      <Paper
        variant="outlined"
        sx={{
          p: 4,
          maxWidth: 560,
          width: '100%',
          textAlign: 'center',
          bgcolor: 'background.default',
          borderRadius: 1,
        }}
      >
        <SearchOffIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />

        <Typography component="h1" variant="h2" sx={{ mb: 1 }}>
          Page not found
        </Typography>

        <Typography variant="body2" color="text.secondary">
          We could not find a page at
        </Typography>

        <Typography
          variant="body2"
          component="p"
          sx={{
            my: 1,
            px: 1.5,
            py: 1,
            fontFamily: 'monospace',
            wordBreak: 'break-all',
            bgcolor: 'action.hover',
            borderRadius: 1,
          }}
        >
          {pathname}
        </Typography>

        {!platform && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            REMUS URLs start with a platform — {`/${DEFAULT_PLATFORM}/...`}
          </Typography>
        )}

        <Button component={Link} to={homeLink} variant="contained" sx={{ mt: 2 }}>
          Back to home
        </Button>
      </Paper>
    </Box>
  );
};

export default NotFoundPage;
